<template>
  <b-modal id="customer-show-document" ref="modal" :title="dialog_title" hide-footer>
    <choose-pharmaceutical ref="choosepharma" @add="addPharma"></choose-pharmaceutical>
    <div class="row form-group">
      <div class="col-sm-12">
        <customer-search id="show_document_customer" ref="search" :locked="locked" @customerSelected="customerSelected"
          @customerDeselected="customerDeselected"></customer-search>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-3">
        <select v-model="type" @change="selected_template = null" id="show_document_type"
          class="custom-select form-control" :disabled="is_editing">
          <option value="consent">Consentimiento</option>
          <option value="proof">Justificante</option>
          <option value="report">Informe</option>
          <option value="prescription">Receta</option>
          <option value="document">Archivo</option>
          <option value="lab_work">Trabajo Laboratorio</option>
        </select>
        <label for="show_document_type" class="wabident-info">Tipo de Documento</label>
      </div>

      <div class="col-sm-6" v-if="is_templatable">
        <v-select v-model="selected_template" :disabled="is_editing" class="wabident-vselect"
          id="show_document_template" :options="template_options"></v-select>
        <label for="show_document_template" class="wabident-info">Plantilla</label>
      </div>

      <div class="col-sm-3" v-if="is_formattable">
        <select v-model="format" @change="selected_template = null" id="show_document_format"
          class="custom-select form-control" :disabled="is_editing">
          <option value="visual">Editor Visual</option>
          <option value="html">HTML</option>
          <option value="pdf">PDF</option>
        </select>
        <label for="show_document_format" class="wabident-info">Formato</label>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-3">
        <input class="form-control" type="date" id="show_document_date" v-model="created_at" />
        <label for="show_document_date" class="wabident-info">Fecha <span v-if="is_prescription">prescripción</span>
        </label>
      </div>

      <div class="col-sm-2">
        <input class="form-control" type="time" id="show_document_hour" v-model="hour" />
        <label for="show_document_hour" class="wabident-info">Hora</label>
      </div>

      <div class="col-sm-3">
        <select v-model="doctor_id" id="show_document_doctor" class="custom-select form-control"
          :disabled="lock_doctor">
          <option :value="null">Selecciona Doctor/a</option>
          <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
            {{ doctor.name }}
          </option>
        </select>
        <label for="show_document_doctor" class="wabident-info">Doctor principal (Obligatorio)</label>
      </div>

      <div class="col-sm-3">
        <select v-model="second_doctor_id" id="show_document_second_doctor" class="custom-select form-control">
          <option :value="null">Selecciona Adjunto/a</option>
          <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
            {{ doctor.name }}
          </option>
        </select>
        <label for="show_document_second_doctor" class="wabident-info">Personal adjunto (opcional)</label>
      </div>
    </div>

    <div class="row form-group">
      <div class="col">
        <input id="show_document_title" type="text" class="form-control" v-model="title" />
        <label v-if="is_prescription" for="show_document_title" class="wabident-info">Prescripción (Obligatoria)</label>
        <label v-else for="show_document_title" class="wabident-info">Título del documento (Obligatorio)</label>
      </div>

      <div class="col-sm-3" v-if="is_lab_work">
        <input id="show_lab_work_date" type="date" class="form-control" v-model="custom_fields['lab_work_date']" />
        <label for="show_lab_work_date" class="wabident-info">Fecha Realización Prevista</label>
      </div>

      <div class="col-sm-3" v-if="is_lab_work">
        <v-select v-model="selected_laboratory" class="wabident-vselect" id="show_laboratory_id"
          :options="laboratory_options"></v-select>
        <label for="show_laboratory_id" class="wabident-info">Laboratorio</label>
      </div>

      <div class="col-sm-2" v-if="is_lab_work">
        <input id="show_lab_work_cost" type="number" min="0" step="0.01" class="form-control"
          v-model="custom_fields['lab_work_cost']" />
        <label for="show_lab_work_cost" class="wabident-info">Coste(€)</label>
      </div>

      <div class="col-sm-3" v-if="is_prescription">
        <button class="btn btn-block btn-wabident-round mt-2" @click="addPharmaceutical">
          <i class="fas fa-search"></i> Buscar fármaco ...
        </button>
      </div>

      <div v-if="is_revokable" class="col-sm-3">
        <input type="date" v-model="revoke_date" id="show_document_revoke_date" class="form-control" />
        <label for="show_document_revoke_date" class="wabident-info">Fecha de Revocación (Marcar para revocar)</label>
      </div>
    </div>

    <div v-if="is_prescription" class="row form-group">
      <div class="col-sm-1">
        <input type="number" v-model="custom_fields['numeroenvases']" id="show_document_numeroenvases"
          class="form-control" />
        <label for="show_document_numeroenvases" class="wabident-info">Envases</label>
      </div>

      <div class="col-sm-1">
        <input type="number" v-model="custom_fields['unidadesporenvase']" id="show_document_unidadesporenvase"
          class="form-control" />
        <label for="show_document_unidadesporenvase" class="wabident-info">Uds. por envase</label>
      </div>

      <div class="col-sm-1">
        <input type="number" v-model="custom_fields['numeroordendispensacion']"
          id="show_document_numeroordendispensacion" class="form-control" />
        <label for="show_document_numeroordendispensacion" class="wabident-info">Ord. Dispensación</label>
      </div>

      <div class="col-sm-3">
        <input type="text" v-model="custom_fields['posologia']" id="show_document_posologia" class="form-control" />
        <label for="show_document_posologia" class="wabident-info">Posología</label>
      </div>

      <div class="col-sm-3">
        <input type="text" v-model="custom_fields['pauta']" id="show_document_pauta" class="form-control" />
        <label for="show_document_pauta" class="wabident-info">Pauta</label>
      </div>

      <div class="col-sm-3">
        <input type="text" v-model="custom_fields['duracion']" id="show_document_duracion" class="form-control" />
        <label for="show_document_duracion" class="wabident-info">Duración del tratamiento</label>
      </div>
    </div>


    <div v-if="is_prescription" class="row form-group">
      <div class="col-sm-6">
        <input type="text" v-model="custom_fields['instruccionespaciente']" id="show_document_paciente"
          class="form-control" />
        <label for="show_document_instruccionespaciente" class="wabident-info">Instrucciones para el paciente</label>
      </div>
      <div class="col-sm-6">
        <input type="text" v-model="custom_fields['diagnostico']" id="show_document_diagnostico" class="form-control" />
        <label for="show_document_diagnostico" class="wabident-info">Diagnóstico</label>
      </div>
    </div>

    <div v-if="is_prescription" class="row form-group">
      <div class="col-sm-6">
        <input type="text" v-model="custom_fields['instruccionesfarmacia']" id="show_document_farmacia"
          class="form-control" />
        <label for="show_document_instruccionesfarmacia" class="wabident-info">Instrucciones para la farmacia</label>
      </div>
      <div class="col-sm-6">
        <input class="form-control" type="date" id="show_document_dispensacion"
          v-model="custom_fields['fechaprevistadispensacion']" />
        <label for="show_document_dispensacion" class="wabident-info">Fecha prevista de dispensación
        </label>
      </div>
    </div>

    <div v-if="is_prescription && is_editing" class="row form-group">
      <div class="col-sm-6">
        <input type="text" v-model="custom_fields['codigoreceta']" id="show_document_code" class="form-control"
          readonly />
        <label for="show_document_code" class="wabident-info">Código de la receta</label>
      </div>

      <div class="col-sm-6">
        <input type="text" v-model="custom_fields['numeroreceta']" id="show_document_code" class="form-control"
          readonly />
        <label for="show_document_code" class="wabident-info">Número de la receta</label>
      </div>
    </div>

    <div class="row form-group">
      <div v-if="is_downloadable" class="col">
        <div class="mb-2" v-if="is_uploaded">
          Archivo subido
          <a class="btn-link" :href="file_link">{{ document.file_name }}</a>
        </div>

        <b-form-file v-model="file" :state="Boolean(file)" :placeholder="file_placeholder" class="wabident-file-input"
          :required="!is_editing" :accept="file_accept" :disabled="is_loading"></b-form-file>
      </div>
      <div v-else-if="!template_id && !is_prescription" class="col">
        <quill-editor id="show_document_content" :options="options" v-model="content"></quill-editor>
        <label for="show_document_content" class="wabident-info">Texto del documento</label>
      </div>
    </div>

    <div class="form-group row" v-if="has_custom_fields">
      <div class="col-md-12">
        <h6><strong>CAMPOS PERSONALIZADOS</strong></h6>
      </div>
      <div v-for="(name, field) in parsed_custom_fields" :key="field" class="col-md-6 mb-2">
        <label :for="'parsed_custom_field_' + field">{{ name }}</label>
        <input class="form-control" type="text" :for="'parsed_custom_field_' + field" v-model="custom_fields[field]">
      </div>
    </div>

    <div class="form-group row" v-if="!embed">
      <div class="col-sm-6">
        <select v-model="appointment_id" id="show_document_appointment" class="custom-select form-control">
          <option value="null">Selecciona cita &hellip;</option>
          <option :value="app.id" :key="app.id" v-for="app in appointments">
            {{ appName(app) }}
          </option>
        </select>
        <label for="show_document_appointment" class="wabident-info">Cita asociada al documento</label>
      </div>
      <div class="col-sm-6">
        <select v-model="history_entry_id" id="show_document_entry" class="custom-select form-control">
          <option :value="null">Selecciona historia &hellip;</option>
          <option :value="his.id" :key="his.id" v-for="his in history_entries">
            {{ historyName(his) }}
          </option>
        </select>
        <label for="show_document_entry" class="wabident-info">Historia asociada al documento</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col text-center">
        <button :disabled="is_loading" @click="onDelete" v-show="is_editing && !is_prescription"
          class="btn btn-wabident-delete float-left" style="width: 53.6px; height: 53.6px"></button>

        <button @click="submitDocument" class="btn btn-primary btn-wabident vertical-align-middle"
          :disabled="!is_valid || is_loading">
          <span v-if="is_loading">
            Guardando
            <i class="fas fa-spin fa-circle-notch"></i>
          </span>
          <span v-else-if="is_editing">Modificar Documento</span>
          <span v-else>Guardar Documento</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BIconFileEarmarkPerson } from 'bootstrap-vue';

export default {
  props: {
    locked: { default: true },
    embed: { default: false }
  },
  data() {
    return {
      lock_doctor: false,
      is_loading: false,
      is_editing: false,
      document: null,
      hour: null,
      selected_customer: null,
      created_at: new Date().toISODate(),
      revoke_date: "",
      doctor_id: null,
      second_doctor_id: null,
      selected_template: null,
      selected_laboratory: null,
      title: "",
      content: "",
      type: "consent",
      format: null,
      file: null,
      templates: [],
      laboratories: [],
      appointment_id: null,
      history_entry_id: null,
      appointments: [],
      history_entries: [],
      clinics: [],
      custom_fields: {},
      options: {
        placeholder: "Introduce texto ...",
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }, { list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["blockquote", "code-block", "link"],
            ["clean"],
          ],
        },
      },
    };
  },
  watch: {
    doctor_id(val) {
      if (this.is_prescription) {
        this.checkRecipeAvailability();
      }
    },
    type(val) {
      if (this.is_prescription) {
        this.format = 'html';
        this.checkRecipeAvailability();
      } else {
        this.getTemplates();
      }
    },
    selected_template(val) {
      if (val && val.template) {
        this.title = val.template.title;
        this.content = val.template.content;
      }
    },
    selected_laboratory(val) {
      if (val && val.laboratory) {
        this.custom_fields.laboratory_id = val.laboratory.id;
      } else {
        this.custom_fields.laboratory_id = null;
      }
    }
  },
  computed: {
    is_lab_work() {
      return this.type == 'lab_work';
    },
    is_prescription() {
      return this.type == 'prescription';
    },
    has_custom_fields() {
      return this.parsed_custom_fields && Object.values(this.parsed_custom_fields).length;
    },
    parsed_custom_fields() {
      if (this.selected_template) {
        let ret = {};
        this.selected_template.template.parsed_custom_fields.forEach((x) => {
          ret[x] = this.getCleanCustomField(x);
        });
        return ret;
      }
      return {};
    },
    template_id() {
      if (this.selected_template) {
        return this.selected_template.template.id;
      }
      return null;
    },
    template_options() {
      return this.templates.map((t) => {
        return {
          label: t.title,
          value: t.id,
          template: t,
        }
      });
    },
    laboratory_options() {
      return this.laboratories.map((t) => {
        return {
          label: t.name,
          value: t.id,
          laboratory: t,
        }
      });
    },
    is_valid() {
      if (this.is_loading) return false;
      if (!this.title) return false;
      if (!this.hour) return false;
      if (!this.type) return false;
      if ((this.type == "document" || this.format == 'pdf') && !this.file) return false;
      return true;
    },
    is_downloadable() {
      return this.type && (
        (this.type == "document") ||
        (this.format == "pdf")
      );
    },
    is_formattable() {
      return (
        this.type && !this.template_id && this.type !== 'document' && this.type !== 'prescription' && this.type !== 'lab_work'
      );
    },
    is_templatable() {
      return (
        this.type && this.type !== "document" && this.type !== "prescription" && this.format != 'pdf' && this.type !== 'lab_work'
      );
    },
    is_uploaded() {
      return (
        this.is_editing &&
        this.is_downloadable &&
        this.document &&
        this.document.file_name &&
        this.document.file_name != ""
      );
    },
    file_link() {
      if (!this.is_uploaded) return "";
      return `/customer/${this.selected_customer.id}/document/${this.document.id}/download?action=download`;
    },
    file_accept() {
      return this.format == 'pdf' ? 'application/pdf' : '';
    },
    file_placeholder() {
      if (this.is_uploaded) return "Elige un nuevo archivo para subir";

      return "Elige un archivo";
    },
    doctors() {
      if (!this.clinic) return [];
      return this.clinic.doctors.filter((d) => {
        return d.is_active || this.doctor_id == d.doctor.id || this.second_doctor_id == d.doctor.id;
      });
    },
    dialog_title() {
      return this.is_editing ? "Editar Documento" : "Crear Documento";
    },
    is_revokable() {
      return this.is_editing && this.type == "consent";
    },
    day_slots() {
      if (!this.clinic) return [];
      return this.clinic.schedule.daily_timeslots[this.dayindex];
    },
    dayindex() {
      let d = moment(this.created_at).toDate().getDay();
      if (d == 0) return 6;
      return d - 1;
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic"]),
  },
  methods: {
    getCleanCustomField(field) {
      return field.replaceAll('_', ' ').replaceAll('-', ' ');
    },
    stripHtml(html) {
      let tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    appName(app) {
      return moment(app.date_from).format('DD/MM/YY - HH:mm') + ' - ' + app.notes;
    },
    historyName(h) {
      return moment(h.created_at).format('DD/MM/YY') + ' - ' + this.stripHtml(h.notes);
    },
    updateAppointments(customer) {
      this.appointments = [];
      this.history_entries = [];
      this.clinics = [];

      axios.get(`/customer/${customer.id}/appointments`).then((response) => {
        this.appointments = response.data.appointments;
        this.clinics = response.data.clinics;
      });

      axios.get(`/customer/${customer.id}/history_entries`).then((response) => {
        this.history_entries = response.data;
      });
    },
    customerSelected(customer) {
      if (customer) {
        this.selected_customer = customer;
      }
    },
    customerDeselected() {
      this.selected_customer = null;
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    showNew(customer, appointment_id = null, history_entry_id = null, doctor_id = null, type = 'consent', title = '') {
      this.is_editing = false;
      this.document = null;
      this.type = type;
      this.created_at = new Date().toISODate();
      this.doctor_id = doctor_id;
      this.lock_doctor = (doctor_id !== null)
      this.second_doctor_id = null;
      this.title = title;
      this.content = "";
      this.revoke_date = "";
      this.selected_template = null;
      this.selected_laboratory = null;
      this.hour = moment().format('HH:mm');
      this.appointment_id = appointment_id;
      this.history_entry_id = history_entry_id;
      this.format = 'visual';
      this.custom_fields = {};

      this.selected_customer = customer;
      setTimeout(() => {
        this.$refs.search.select(customer);
      }, 100);

      this.updateAppointments(customer);
      this.getTemplates();
      this.getLaboratories();
      this.show();
      setTimeout(() => {
        this.getConsentDocumentStatus();
      }, 200);
    },
    showEdit(customer, document) {
      this.is_editing = true;
      this.document = document;
      this.selected_customer = customer;
      this.lock_doctor = false;
      this.type = document.type;
      this.created_at = moment(document.created_at).toDate().toISODate();
      this.doctor_id = document.doctor_id;
      this.second_doctor_id = document.second_doctor_id;
      this.title = document.title;
      this.content = document.content;
      this.format = document.format;
      if (this.format == 'html') {
        this.format = 'visual';
      }

      if (WabiDent.isObject(document.custom_fields)) {
        this.custom_fields = document.custom_fields;
      } else {
        this.custom_fields = JSON.parse(document.custom_fields);
        if (!WabiDent.isObject(this.custom_fields)) {
          this.custom_fields = {};
        }
      }

      this.hour = this.getHour(document.created_at);
      this.appointment_id = document.appointment_id;
      this.history_entry_id = document.history_entry_id;

      if (document.revoke_date && document.revoke_date != "") {
        this.revoke_date = moment(document.revoke_date).toDate().toISODate();
      } else {
        this.revoke_date = "";
      }

      setTimeout(() => {
        this.$refs.search.select(customer);
      }, 100);

      this.selected_laboratory = null;
      this.selected_template = null;

      this.updateAppointments(customer);
      this.getTemplates(document.template_id);
      this.getLaboratories(this.custom_fields.laboratory_id);
      this.show();
    },
    getFirstHour() {
      return this.day_slots.morning.start[0];
    },
    getHour(date) {
      return moment(date).format("HH:mm");
    },
    getFormData() {
      let ret = new FormData();

      ret.append("created_at", this.created_at);

      if (this.doctor_id) {
        ret.append("doctor_id", this.doctor_id);
      }

      ret.append("customer_id", this.selected_customer.id);
      ret.append("title", this.title);
      ret.append("content", this.content);
      ret.append("type", this.type);
      ret.append("format", this.format);
      ret.append("revoke_date", this.revoke_date);
      ret.append("template_id", this.template_id);
      ret.append("hour", this.hour);
      ret.append("custom_fields", JSON.stringify(this.custom_fields));

      if (this.second_doctor_id) {
        ret.append("second_doctor_id", this.second_doctor_id);
      }

      if (this.appointment_id) {
        ret.append("appointment_id", this.appointment_id);
      }

      if (this.history_entry_id) {
        ret.append("history_entry_id", this.history_entry_id);
      }

      if (this.clinic) {
        ret.append("clinic_id", this.clinic.id);
      }

      if (this.type == "document" || this.format == "pdf") {
        ret.append("file", this.file);
      }

      return ret;
    },
    checkEmpty(value) {
      return (!value || value == '' || value == null);
    },
    getConsentDocumentStatus() {
      if (this.type !== 'consent') {
        return true;
      }

      let errors = [];

      if (this.checkEmpty(this.selected_customer.full_name)) {
        errors.push('Nombre completo');
      }

      if (this.checkEmpty(this.selected_customer.birth_date)) {
        errors.push('Fecha de nacimiento');
      }

      if (errors.length > 0) {
        console.log(errors);
        let msg = 'Para poder emitir consentimientos se deben rellenar los siguientes campos de la Ficha de Paciente:  <strong>' + errors.join(', ') + '</strong>';
        this.errorwindow.show('Error', msg);
        return false;
      }

      return true;
    },
    submitDocument() {
      if (!this.getConsentDocumentStatus()) {
        return;
      }

      if (this.is_editing) {
        this.editDocument();
      } else {
        this.createDocument();
      }
    },
    createDocument() {
      if (!this.is_loading) {
        this.is_loading = true;
        let formData = this.getFormData();
        axios
          .post("/document", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.msgwindow.success("Documento creado con éxito");
            this.$emit("submit", response.data);
            this.$emit("add", response.data);
            this.hide();
          })
          .catch((err) => {
            console.log("[ERR] createDocument", err);
            this.errorwindow.show("Error", "Error creando documento");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    editDocument() {
      if (!this.is_loading) {
        this.is_loading = true;
        let formData = this.getFormData();
        axios
          .post(`/document/${this.document.id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.msgwindow.success("Documento modificado con éxito");
            this.$emit("submit", response.data);
            this.$emit("edit", response.data);
            this.hide();
          })
          .catch((err) => {
            console.log("[ERR] editDocument", err);
            this.errorwindow.show("Error", "Error edidanto documento");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    getLaboratories(selected_laboratory_id) {
      axios
        .get('/laboratories')
        .then((resp) => {
          this.laboratories = resp.data;
          if (selected_laboratory_id) {
            this.laboratories.forEach((t) => {
              if (t.id == selected_laboratory_id) {
                this.selected_laboratory = {
                  label: t.name,
                  value: t.id,
                  laboratory: t,
                }
              }
            });
          }
        })
        .catch((err) => {
          this.laboratories = [];
          this.msgwindow.error("Error cargando Laboratorios");
        });
    },
    getTemplates(selected_template_id) {
      axios
        .get("/document_templates", {
          params: {
            type: this.type,
          },
        })
        .then((resp) => {
          this.templates = resp.data;
          if (selected_template_id) {
            this.templates.forEach((t) => {
              if (t.id == selected_template_id) {
                this.selected_template = {
                  label: t.title,
                  value: t.id,
                  template: t,
                }
              }
            });
          }
        })
        .catch((err) => {
          this.templates = [];
          this.msgwindow.error("Error cargando plantillas de documento");
        });
    },
    onDelete() {
      this.errorwindow.show(
        "Confirmación",
        "¿Desea borrar el documento?",
        "Borrar",
        "Cancelar",
        () => {
          if (!this.is_loading) {
            this.is_loading = true;
            axios
              .post(`/document/${this.document.id}`, { _method: "delete" })
              .then((resp) => {
                this.msgwindow.success("Documento borrado con éxito");
                this.$emit("submit");
                this.hide();
              })
              .catch((err) => {
                console.log("[ERR] deleteDocument", err);
                this.errorwindow.show("Error", "Error borrando el documento");
              })
              .then(() => {
                this.is_loading = false;
              });
          }
        }
      );
    },
    addPharmaceutical() {
      this.$refs.choosepharma.show();
    },
    addPharma(pharma) {
      this.content = pharma.title;
      this.title = pharma.title;
      this.custom_fields.numeroenvases = 1;
      this.custom_fields.numeroordendispensacion = 1;
      this.custom_fields.unidadesporenvase = pharma.units;
      this.custom_fields.formafarmaceutica = pharma.form;
    },
    checkRecipeAvailability() {
      if (!this.doctor_id) {
        return;
      }

      let params = {
        doctor_id: this.doctor_id,
      };

      axios.get(`/clinic/${this.clinic.id}/recipe_availability`, { params }).then((response) => {
        if (response.data.remaining_recipes <= 0) {
          this.errorwindow.show('Error', 'No quedan recetas en el Talonario XML para este Doctor.<br> <strong>Por favor, sube un Talonario nuevo en "Mi Clinica > Recetas"</strong>');
        } else if (response.data.remaining_recipes <= 10) {
          this.errorwindow.show('Advertencia', `Sólo quedan quedan ${response.data.remaining_recipes} recetas en el Talonario XML para este doctor.<br> <strong>Por favor, prepara un Talonario nuevo a la mayor brevedad posible</strong>`);
        }
      }).catch((error) => {
        this.msgwindow.error('Error cargando recetas disponibles del Talonario');
      });
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss">
#customer-show-document {
  .modal-dialog {
    max-width: 60vw;
  }

  #show_document_content .ql-container {
    height: 250px;
    overflow-y: scroll;
  }
}
</style>
